module.exports = __webpack_public_path__ + "static/media/profile-1.dc65159e.png";